import { Capacitor } from '@capacitor/core';
import React, { useContext, useEffect, useState } from 'react';
import filesystem from '../../app/filesystem/filesystem';
import { getExistingAssetUrl } from '../../app/models/content';
import { RootStoreContext } from '../../app/stores/rootStore';

interface IParams {
  className?: string;
}

export const LogoCompany: React.FC<IParams> = ({ className }) => {
  const rootStore = useContext(RootStoreContext);
  const { isNativeApp, company } = rootStore.commonStore;
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    const ts = new Date().getMilliseconds();
    const logoFilename = "logo.png";
    const defaultUri = `${getExistingAssetUrl("companies", company!.name, logoFilename)}?ts=${ts}`;
    if (isNativeApp) {
      filesystem.GetLocalUrl.companyLogo(company!, logoFilename)
        .then((url) => {
          if (url) setImgSrc(Capacitor.convertFileSrc(url));
          else setImgSrc(defaultUri);
        })
        .catch(() => setImgSrc(defaultUri));
    } else setImgSrc(defaultUri);
  }, [isNativeApp, company]);

  return <img alt={company!.name} className={className} src={imgSrc} />;
}
export default (LogoCompany);